exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".confirmation-modal .ant-confirm-body {\n  padding: 20px 20px 0 20px; }\n\n.confirmation-modal .ant-modal-footer {\n  border: none;\n  padding: 0 36px 36px 36px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./client/modules/core/Modal/ConfirmationModal/style.scss
// module id = 1039
// module chunks = 0